import type { FC } from 'react';
import React, { createContext, useContext } from 'react';

import type { ISmeStickyTableProps } from './models';
import { useWidthCalculator } from './components/sticky-table/hooks';

const TableContext = createContext<Array<number | string>>([]);

export const useTableContext = () => useContext(TableContext);

export const SmeStickyTable: FC<ISmeStickyTableProps> = ({
    StickyContainer,
    children,
    columnsWidth = [],
}) => {
    const calculatedColumnsWidth = useWidthCalculator(columnsWidth);

    return (
        <StickyContainer>
            <TableContext.Provider value={calculatedColumnsWidth}>{children}</TableContext.Provider>
        </StickyContainer>
    );
};
